import { render } from "./ClassRecordsContainer.vue?vue&type=template&id=6bbfd539&scoped=true&ts=true"
import script from "./ClassRecordsContainer.vue?vue&type=script&lang=ts"
export * from "./ClassRecordsContainer.vue?vue&type=script&lang=ts"

import "./ClassRecordsContainer.vue?vue&type=style&index=0&id=6bbfd539&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbfd539"]])

export default __exports__